export default "__VITE_ASSET__CDsrrC4Y__"